import React from 'react';

export const StartupLoading = () => (
  <div
    style={{
      width:    '100%',
      height:   '100%',
      position: 'fixed',
      top:      0,
      left:     0,
      zIndex:   999999,
    }}
  />
);